import {
  Award01Icon,
  File02Icon,
  Note01Icon
} from '@hugeicons/react'

import { sanitizeHtml } from '@/shared/lib/html/sanitize'
import type { ReactNode } from 'react'

import { Card } from '@/shared/ui/Card'

import { getEvidenceKindLabel } from '../../lib/evidenceKindLabels'
import { missionShowCardBodyClass, missionShowCardClass } from './showCard'

type MissionAboutCardProps = {
  description?: string | null
  evidenceKind?: string | null
  confirmationRequired?: boolean
}

const InfoRow = ({
  icon,
  title,
  children
}: {
  icon: ReactNode
  title: string
  children: ReactNode
}) => (
  <div className="border-t border-contour pt-4">
    <div className="flex items-start gap-2.5">
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-surface text-primary">
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="m-0 text-xs font-bold text-gray-900">{title}</h3>
        <div className="mt-1 text-xs leading-snug text-gray-600">
          {children}
        </div>
      </div>
    </div>
  </div>
)

export const MissionAboutCard = ({
  description,
  evidenceKind,
  confirmationRequired = true
}: MissionAboutCardProps) => {
  if (!description && !confirmationRequired) return null

  return (
    <Card className={missionShowCardClass}>
      <Card.Body className={missionShowCardBodyClass}>
        <div className="flex items-center gap-2">
          <Note01Icon size={18} variant="duotone" className="text-primary" aria-hidden />
          <h2 className="m-0 text-sm font-bold text-gray-900">Sobre a missão</h2>
        </div>

        {description && (
          <div
            className="rich-text text-sm leading-relaxed text-gray-700"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
          />
        )}

        {confirmationRequired && (
          <>
            <InfoRow
              icon={<Award01Icon size={16} variant="duotone" aria-hidden />}
              title="Critério de avaliação"
            >
              Nossa equipe analisará sua resposta com base na coerência e
              relevância em relação ao desafio.
            </InfoRow>

            <InfoRow
              icon={<File02Icon size={16} variant="duotone" aria-hidden />}
              title="Formato aceito"
            >
              <span className="font-semibold text-gray-800">
                {getEvidenceKindLabel(evidenceKind)}
              </span>
            </InfoRow>
          </>
        )}
      </Card.Body>
    </Card>
  )
}
